/* global window, $ */

'use strict';

// eslint-disable-next-line no-undef
__webpack_public_path__ = assetsUrl;

$(window).load(() => {
  if (window.payload === undefined || window.payload.sharing === undefined) {
    return;
  }
  const fb_promise = import(/* webpackChunkName: "facebook" */ '../../../../../modules/sharing/frontend/facebook_script');
  fb_promise
    .then(facebook_script => {
      facebook_script.fbPostponedScriptLoading();
    })
    .catch(err => {
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.log('Failed to load facebook_script', err);
      }
    });
});



// WEBPACK FOOTER //
// ./core/frontend/webpack/async_scripts/loaders/facebook.js